/* CIB - Auto add discount product to cart drawer */
(function () {
  async function cibAutoAddDealToCartDrawer() {
    const params = new URLSearchParams(window.location.search);

    const shouldAutoAdd = params.get('cib_auto_add') === '1';
    const variantId = params.get('cib_variant_id');
    const quantity = Number(params.get('cib_qty') || '1');
    const discountCode = params.get('cib_discount');

    if (!shouldAutoAdd || !variantId) return;

    try {
      // Prevent duplicate auto-add if browser restores page
      const sessionKey = `cib_auto_add_${variantId}_${discountCode || 'no_discount'}`;
      if (sessionStorage.getItem(sessionKey) === 'done') return;
      sessionStorage.setItem(sessionKey, 'done');

      // Apply discount without navigating away
      if (discountCode) {
        await fetch(`/discount/${encodeURIComponent(discountCode)}`, {
          method: 'GET',
          credentials: 'same-origin'
        });
      }

      // Add product to cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity
        })
      });

      if (!addResponse.ok) {
        throw new Error('CIB auto add failed');
      }

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        const sectionsToRender = cartDrawer
          .getSectionsToRender()
          .map((section) => section.section);

        const sectionsResponse = await fetch(`/?sections=${sectionsToRender.join(',')}`, {
          credentials: 'same-origin'
        });

        const sections = await sectionsResponse.json();

        if (typeof cartDrawer.renderContents === 'function') {
          await cartDrawer.renderContents({ sections }, true);
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      }

      // Clean URL so refresh does not add the product again
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('cib_auto_add');
      cleanUrl.searchParams.delete('cib_variant_id');
      cleanUrl.searchParams.delete('cib_qty');
      cleanUrl.searchParams.delete('cib_discount');

      window.history.replaceState({}, document.title, cleanUrl.toString());
    } catch (error) {
      console.error('[CIB Auto Add Deal Error]', error);
      sessionStorage.removeItem(`cib_auto_add_${variantId}_${discountCode || 'no_discount'}`);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cibAutoAddDealToCartDrawer);
  } else {
    cibAutoAddDealToCartDrawer();
  }
})();